import { useEffect, useRef, useState } from "react";
import { streamSSE } from "@/lib/sse";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WelcomeNote = ({ id, token }) => {
  const [text, setText] = useState("");
  const [state, setState] = useState("writing");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    streamSSE(`${API}/waitlist/${id}/welcome`, { token }, (t) => setText((x) => x + t))
      .then(() => setState("done"))
      .catch(() => setState("error"));
  }, [id, token]);

  if (state === "error" || (state === "done" && !text)) return null;
  return (
    <p className={`welcome-note ${text ? "" : "is-writing"}`} data-testid="welcome-note" aria-live="polite">
      {text || "writing you a note..."}
    </p>
  );
};
